// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"bf8a23e3","260":"ae2bb099","315":"6ce9b369","333":"ede692d5","681":"f9109374","714":"163c539f","787":"0763a1a7","849":"1ab8c152","936":"4bb61c67"}[chunkId] + ".chunk.js";
};